import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Icon from "components/Icon";
import Spinner from "components/Spinner";
import Button from "components/Button";
import { CartContext } from "components/cart";
import truncateIt from "text-clipper";
import { useSwipeable } from "react-swipeable";
import Api from "../Api";
import classNames from "lib/classNames";
import { API_GATEWAY_NEW } from "aws-exports";
import Cookies from "js-cookie";
import useLocalStorage from "hooks/useLocalStorage";
import API from "../Api";

const CodForm = () => {
  const {
    cart_settings,
    Utils,
    get_total,
    isPreview,
    shop_url,
    shopify_cart_items,
    shopify_cart_upsells,
    cart_currency,
    discountCode,
    cart_token,
    showComfirmOrderLoading,
    cartNote,
    orderCodForm,
    setOrderCodForm,
    isCodFormSubmitted,
    setIsCodFormSubmitted,
    AppLocalStorage
  } = useContext(CartContext);
  const {
    cod_settings: { form, confirm_button, loading_button, is_form_in_cart },
    modules: { checkout_button }
  } = cart_settings;
  // const [isCodFormSubmitted, setIsCodFormSubmitted] = useState(false);
  const [discount, setDiscount] = useLocalStorage("monster_discount_code", "", AppLocalStorage);
  // const [orderCodForm, setOrderCodForm] = useState({});

  const generateCheckoutUrl = (discount = null, esid = null) => {
    const queryString = [
      discount && `discount=${encodeURIComponent(discount)}`,
      esid && `attributes[esid]=${esid}`
    ].filter(Boolean);
    return `${window.location.origin}/checkout${
      queryString.length ? `?${queryString.join("&")}` : ""
    }`;
  };

  const setNote = () => {
    //update items
    API.post(`${window.location.origin}/cart/update.js`, {
      note: cartNote
    })
      .then(({ data }) => {
        // console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={classNames("w-full min-w-full flex flex-col h-auto")}>
      {form.map((module, index) => {
        return (
          <Module
            key={index}
            {...module}
            {...{ orderCodForm, setOrderCodForm, isCodFormSubmitted }}
          />
        );
      })}

      {!is_form_in_cart && (
        <div className={classNames("p-2 px-5 ")}>
          <InfoItem
            name={checkout_button.subtotal}
            value={get_total("subtotal")}
          />
          <CodCheckoutButton
            {...{
              setNote,
              generateCheckoutUrl,
              discount
            }}
          />
        </div>
      )}
    </div>
  );
};

const Module = ({
  label,
  isRequired,
  placeholder,
  type,
  options,
  orderCodForm,
  setOrderCodForm,
  isCodFormSubmitted
}) => {
  const handleChange = (value) => {
    setOrderCodForm({
      ...orderCodForm,
      [label]: value.target.value
    });
  };

  const hasError = isRequired && isCodFormSubmitted && !orderCodForm[label];

  return (
    <div className={classNames("p-2 px-5 ")}>
      <div>
        {isRequired ? "* " : ""}
        {label}
      </div>
      {(!type ||
        type === "string" ||
        type === "email" ||
        type === "name" ||
        type === "phone") && (
        <input
          name={label}
          placeholder={placeholder || ""}
          className={classNames(
            "w-full min-w-full h-10 rounded border-gray-500 border px-2 py-1 bg-white",
            {
              "border-red-400": hasError
            }
          )}
          value={orderCodForm[label] || ""}
          onChange={handleChange}
        />
      )}
      {type === "dropdown" && (
        <select
          value={orderCodForm[label]}
          className={classNames(
            "w-full min-w-full h-10 rounded border-gray-500 border px-2 py-1 bg-white"
          )}
        >
          {options.map((option) => {
            return <option> {option} </option>;
          })}
        </select>
      )}
      {type === "textarea" && (
        <textarea
          name={label}
          placeholder={placeholder || ""}
          rows="2"
          className={classNames(
            "w-full min-w-full  rounded border-gray-500 border px-2 py-1 bg-white",
            {
              "border-red-400": hasError
            }
          )}
          value={orderCodForm[label] || ""}
          onChange={handleChange}
        />
      )}
      {hasError && (
        <div>
          <small className="error">This field is required</small>
        </div>
      )}
    </div>
  );
};

const InfoItem = ({
  name: { text, font_size, color },
  value,
  negative = false
}) => {
  const {
    Utils,
    cart_settings: { money_format }
  } = useContext(CartContext);
  // const original = get_total('discount') > 0 ? get_total('original') : null;
  return (
    <div
      className={classNames("pb-3 flex items-center font-bold")}
      style={{
        fontSize: Utils.em(font_size),
        color: Utils.formatColor(color)
      }}
    >
      <span className={classNames("flex-1 flex-grow")}>{text}</span>
      <AnimatedNumber
        component="span"
        value={value}
        formatValue={(n) =>
          `${negative ? "-" : ""}${Utils.formatMoney(n, money_format)}`
        }
      />
    </div>
  );
};
const AnimatedNumber = ({ value, style = {}, formatValue = null }) => (
  <span
    {...{ style }}
    dangerouslySetInnerHTML={{
      __html: formatValue ? formatValue(value) : value
    }}
  />
);

export const CodCheckoutButton = ({
  setNote,
  generateCheckoutUrl,
  discount
}) => {
  const {
    cart_settings,
    Utils,
    isPreview,
    shop_url,
    shopify_cart_items,
    shopify_cart_upsells,
    cart_currency,
    discountCode,
    cart_token,
    showComfirmOrderLoading,
    cartNote,
    orderCodForm,
    setIsCodFormSubmitted
  } = useContext(CartContext);
  const {
    cod_settings: { form, confirm_button, loading_button, is_form_in_cart },
    modules: { checkout_button }
  } = cart_settings;
  const isInputValid = (formInput) =>
    !formInput.isRequired ||
    (formInput.isRequired && orderCodForm[formInput.label]);

  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const checkout = () => {
    setCheckoutLoading(true);
    if (!form.every(isInputValid)) {
      console.log("not valid");
      setIsCodFormSubmitted(true);
      setCheckoutLoading(false);
      return;
    }

    if (isPreview) {
      setCheckoutLoading(true);
      setTimeout(() => {
        setCheckoutLoading(false);
      }, 4000);
      return;
    }
    setNote();
    if (discountCode) {
      window.location.href = generateCheckoutUrl(discountCode.code);
      return;
    }

    API.post(`${API_GATEWAY_NEW}/public/checkout`, {
      shop: shop_url,
      items: shopify_cart_items.map(({ variant_id, product_id, quantity }) => ({
        variant_id,
        product_id,
        quantity
      })),
      note: cartNote,
      u: shopify_cart_upsells,
      cart_currency,
      token: cart_token,
      discountCode: discount ? discount.title : null,
      isCod: true,
      orderCodForm: {
        ...orderCodForm,
        MUP_NAME: form.find((f) => f.type === "name"),
        MUP_PHONE: form.find((f) => f.type === "phone"),
        MUP_EMAIL: form.find((f) => f.type === "email")
      }
    })
      .then(({ data: { order_status_url, total_price } }) => {
        Cookies.remove("monster_cart");
        Cookies.remove("monster_product_id");
        setCheckoutLoading(false);
        if (window.fbq) {
          window.fbq("track", "Purchase", {
            content_ids: shopify_cart_items.map(({ product_id }) => product_id),
            // content_name: data.title,
            content_type: "product",
            contents: shopify_cart_items.map(({ product_id, quantity }) => ({
              id: product_id,
              quantity: quantity
            })),
            //  [
            // 	{
            // 		id: product_id,
            // 		quantity: quantity,
            // 	},
            // ],
            cart_currency,
            value: total_price
          });
        }
        console.log("order_status_url", order_status_url);
        window.location.href = order_status_url;
      })
      .catch((error) => {
        alert("something went wrong");
        setCheckoutLoading(false);
        console.log(error);
      });
  };
  return (
    <button
      className={classNames(
        "custom-btn w-full rounded w-full py-3 mb-3 p-2 px-5 "
      )}
      style={{
        backgroundColor: Utils.formatColor(confirm_button.background),
        fontFamily: "inherit",
        fontSize: Utils.em(confirm_button.font_size),
        color: Utils.formatColor(confirm_button.color),
        // "--hover-background": Utils.formatColor(confirm_button.hoverBackground)
      }}
      // onClick={() => console.log(orderCodForm)}
      onClick={checkout}
      disabled={checkoutLoading || showComfirmOrderLoading}
    >
      {checkoutLoading || showComfirmOrderLoading
        ? loading_button.text
        : confirm_button.text}
    </button>
  );
};
export default CodForm;
